module.exports = __webpack_public_path__ + "static/media/checkmark.c5082fa4.svg";